import { ChangeDetectionStrategy, Component, inject, input, OnChanges } from '@angular/core';

import { CustomCategory } from '@seb/web-common/core/models';
import { ImageService, TrackingService } from '@seb/web-common/core/services';
import { LinkMapper } from '@seb/web-common/core/mappers';
import { ISiblingCategory, SdSiblingCategoriesComponent } from '@seb/web-design-system/sibling-categories';

@Component({
  selector: 'wc-sibling-categories',
  templateUrl: './sibling-categories.component.html',
  styleUrls: ['./sibling-categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdSiblingCategoriesComponent
  ]
})
export class SiblingCategoriesComponent implements OnChanges {
  categoryData = input<CustomCategory>();
  siblingCategories: ISiblingCategory[] = [];

  private readonly imageService = inject(ImageService);
  private readonly trackingService = inject(TrackingService);

  ngOnChanges(): void {
    this.loadSiblingCategories(this.categoryData());
  }

  /**
   * Load sibling categories for category page
   **/
  private loadSiblingCategories(category: CustomCategory) {
    // reset sibling categories array
    this.siblingCategories = [];
    // if no category, return
    if (!category) {
      return;
    }
    // add current category as first element
    this.siblingCategories.push({
      name: category.name,
      code: category.code,
      url: LinkMapper.decodeUrl(category.url),
      thumbnail: this.imageService.normalizeMedia(category.thumbnail)
    });
    // add sibling categories
    category.siblingCategories?.forEach((siblingCategory) => {
      if (siblingCategory?.name !== category.name && siblingCategory?.code !== category.code) {
        this.siblingCategories.push({
          name: siblingCategory?.name,
          code: siblingCategory?.code,
          url: LinkMapper.decodeUrl(siblingCategory?.url),
          thumbnail: this.imageService.normalizeMedia(siblingCategory?.thumbnail)
        });
      }
    });
  }

  /**
   * Track click on sibling category
   **/
  public onClickSiblingCategory(siblingCategory: CustomCategory) {
    this.trackingService.sendEvent('clickNavigationSubCategory', {
      subCategoryName: siblingCategory?.name,
      positionLabel: this.categoryData()?.name
    });
  }
}
